import React from 'react'

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <nav className="bg-white shadow-sm py-4 px-6 flex items-center justify-between">
        <a href="/" className="text-xl font-bold text-black">Jenny Kids</a>
        <a href="/" className="text-sm text-gray-600 hover:text-black transition-colors">← Volver al inicio</a>
      </nav>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Términos y Condiciones</h1>
        <p className="text-sm text-gray-500 mb-10">Última actualización: 26 de abril de 2026</p>

        <div className="space-y-8 text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Aceptación</h2>
            <p>
              Al usar el sitio <strong>www.jennykids.com.co</strong> o al registrar tus datos
              para realizar un pedido, aceptas estos Términos y Condiciones. Si no estás de
              acuerdo, por favor no uses el sitio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Sobre Jenny Kids</h2>
            <p>
              Jenny Kids es una tienda de ropa infantil con sede en Bogotá D.C., Colombia,
              dedicada a la venta de prendas para niños y niñas. Los pedidos se coordinan
              directamente por WhatsApp con confirmación de disponibilidad, tallas y envío.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Proceso de compra</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>El cliente selecciona el producto y completa el formulario de pedido.</li>
              <li>Jenny Kids confirma disponibilidad y precio de envío vía WhatsApp.</li>
              <li>El pago se acuerda directamente entre las partes antes del envío.</li>
              <li>Los pedidos se despachan una vez confirmado el pago.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Precios</h2>
            <p>
              Todos los precios están expresados en pesos colombianos (COP) e incluyen IVA
              cuando aplica. Los precios de envío varían según el municipio de destino y se
              informan antes de confirmar el pedido.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Envíos</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Realizamos envíos a todo Colombia a través de transportadoras nacionales.</li>
              <li>El tiempo de entrega estimado es de 2 a 5 días hábiles según el destino.</li>
              <li>El cliente es responsable de proporcionar una dirección de entrega correcta.</li>
              <li>Jenny Kids no se hace responsable de demoras causadas por la transportadora.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Cambios y devoluciones</h2>
            <p>
              Aceptamos cambios dentro de los <strong>5 días hábiles</strong> siguientes a la
              recepción del producto, siempre que la prenda esté en perfectas condiciones, sin
              uso, con etiquetas originales. El costo del envío de devolución corre por cuenta
              del cliente. Contáctanos por WhatsApp para gestionar el cambio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Uso de Google para iniciar sesión</h2>
            <p>
              Ofrecemos la opción de iniciar sesión con tu cuenta de Google únicamente para
              facilitar el llenado del formulario (nombre y correo). No accedemos a tu correo,
              contactos ni ningún otro dato. Puedes revocar el acceso desde tu cuenta de Google
              en cualquier momento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Propiedad intelectual</h2>
            <p>
              Todos los contenidos del sitio (imágenes, textos, logotipo) son propiedad de
              Jenny Kids o de sus proveedores y están protegidos por las leyes colombianas de
              propiedad intelectual. Queda prohibida su reproducción sin autorización.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Limitación de responsabilidad</h2>
            <p>
              Jenny Kids no será responsable por daños indirectos derivados del uso del sitio.
              En ningún caso la responsabilidad superará el valor del pedido realizado.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Ley aplicable</h2>
            <p>
              Estos términos se rigen por las leyes de la República de Colombia. Cualquier
              controversia será resuelta ante los jueces competentes de Bogotá D.C.
            </p>
          </section>

          <section className="bg-gray-50 rounded-xl p-5 border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">11. Contacto</h2>
            <ul className="space-y-1">
              <li><strong>Sitio web:</strong> <a href="https://www.jennykids.com.co" className="text-blue-600 underline">www.jennykids.com.co</a></li>
              <li><strong>Política de privacidad:</strong> <a href="/privacy" className="text-blue-600 underline">www.jennykids.com.co/privacy</a></li>
              <li><strong>Ubicación:</strong> Bogotá D.C., Colombia</li>
            </ul>
          </section>

        </div>
      </main>

      <footer className="border-t border-gray-100 py-6 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} Jenny Kids — Bogotá, Colombia
      </footer>
    </div>
  )
}

export default Terms
